import React from "react";
import PathOption from "../PathOption";
import PathOptionGroup from "../PathOptionGroup";

function PathBuilderOptionsShortcuts({ t, options, handleOptionChange, osSelected }) {
  return (
    <PathOptionGroup title={t("pathBuilder.categories.shortcuts")}>
      <PathOption
        id="shortest-path"
        label={t("pathBuilder.checkboxes.shortestPath")}
        checked={options.shortestPath}
        onChange={() => handleOptionChange("shortestPath")}
        disabled={!osSelected || options.dabbler || options.rockstarDev}
      />
      <PathOption
        id="dabbler"
        label={t("pathBuilder.checkboxes.dabbler")}
        checked={options.dabbler}
        onChange={() => handleOptionChange("dabbler")}
        disabled={!osSelected || options.shortestPath || options.rockstarDev}
      />
      <PathOption
        id="rockstar-dev"
        label={t("pathBuilder.checkboxes.rockstarDev")}
        checked={options.rockstarDev}
        onChange={() => handleOptionChange("rockstarDev")}
        disabled={!osSelected || options.shortestPath || options.dabbler}
      />
    </PathOptionGroup>
  );
}

export default PathBuilderOptionsShortcuts;
